/**
 * 操作名映射配置
 * 基于 API 文件注释自动生成 + 智能路径解析
 */

// 核心映射规则（基于 src/api 文件中的注释提取）
const API_NAME_MAP = {
  // ===== 日管控相关 (control.js / daily.js) =====
  'QDailyControlApi22': '查询日管控',
  'ADailyControlApi22': '新增日管控',
  'UDailyControlApi22': '编辑日管控',
  'DDailyControlApi22': '删除日管控',
  'QDailyTemplateApi': '查询模板列表',
  'ADailyTemplateApi': '新增模板',
  'UDailyTemplateApi': '修改模板',
  'DDailyTemplateApi': '删除模板',
  'QDailyItemApi': '查询模板主项目',
  'ADailyItemApi': '新增模板主项目',
  'UDailyItemApi': '修改模板主项目',
  'DDailyItemApi': '删除模板主项目',
  'QDailyChildApi': '查询模板子项目',
  'ADailyChildApi': '新增模板子项目',
  'UDailyChildApi': '修改模板子项目',
  'DDailyChildApi': '删除模板子项目',
  'DefaultTemplateApi': '获取默认模板',
  'QDailyRecordApi': '查询记录列表',
  'ADailyRecordApi': '创建记录',
  'UDailyRecordApi': '更新记录',
  'DDailyRecordApi': '删除记录',
  
  // ===== 周排查/月调度 (control.js) =====
  'QWeekControlApi': '查询周排查',
  'AWeekControlApi': '新增周排查',
  'UWeekControlApi': '编辑周排查',
  'DWeekControlApi': '删除周排查',
  'QMonthControlApi': '查询月调度',
  'AMonthControlApi': '新增月调度',
  'UMonthControlApi': '编辑月调度',
  'DMonthControlApi': '删除月调度',
  
  // ===== 企业信息/从业人员 (enterprise.js) =====
  'QMerchantView2': '查询企业信息',
  'UMerchantView2': '编辑企业信息',
  'QEmployeeView2': '查询从业人员',
  'AEmployeeView2': '新增从业人员',
  'UEmployeeView2': '编辑从业人员',
  'DEmployeeView2': '删除从业人员',
  'QRulesApi': '查询制度管理',
  'ARulesApi': '新增制度管理',
  'URulesApi': '编辑制度管理',
  'DRulesApi': '删除制度管理',
  
  // ===== 调度管理 (dispatch.js) =====
  'QCallBackApi': '查询召回管理',
  'ACallBackApi': '新增召回管理',
  'UCallBackApi': '编辑召回管理',
  'DCallBackApi': '删除召回管理',
  'QUnqualifiedApi': '查询不合格品',
  'AUnqualifiedApi': '新增不合格品',
  'UUnqualifiedApi': '编辑不合格品',
  'DUnqualifiedApi': '删除不合格品',
  
  // ===== 追溯管理 (from.js / traceability.js) =====
  'QTraceProductView2': '查询追溯产品',
  'ATraceProductView2': '新增追溯产品',
  'UTraceProductView2': '编辑追溯产品',
  'DTraceProductView2': '删除追溯产品',
  'GenerateQRView2': '生成二维码',
  'QTraceabilityView2': '查询追溯配方',
  'ATraceabilityView2': '新增追溯配方',
  'UTraceabilityView2': '编辑追溯配方',
  'DTraceabilityView2': '删除追溯配方',
  'ProductBatchViewBack': '查询追溯批次',
  'ProductBatchView2': '查询产品批次',
  
  // 完整路径匹配（用于精确识别）
  'POST /frontApis/shop/v1/trace_product/ATraceProductView2': '新增追溯产品',
  'POST /frontApis/shop/v1/traceability/ATraceabilityView2': '新增追溯配方',
  'POST /frontApis/shop/v1/traceability/operationLog': '查询操作日志',
  'POST /frontApis/shop/v1/excel/MessageNotifyApi': '消息通知',
  'POST /frontApis/shop/v1/home/QHomeApi': '查询首页统计',
  
  // ===== 物联网/智能化 (iot.js) =====
  'QIntelligenceApi': '查询智能化管理',
  'AIntelligenceApi': '新增智能化管理',
  'UIntelligenceApi': '编辑智能化管理',
  'DIntelligenceApi': '删除智能化管理',
  'QEstablishMechanismApi': '查询建立过程机制',
  'AEstablishMechanismApi': '新增建立过程机制',
  'UEstablishMechanismApi': '编辑建立过程机制',
  'DEstablishMechanismApi': '删除建立过程机制',
  'QInspectionCycleApi': '查询检查审核周期',
  'AInspectionCycleApi': '新增检查审核周期',
  'UInspectionCycleApi': '编辑检查审核周期',
  'DInspectionCycleApi': '删除检查审核周期',
  'QCorrectiveApi': '查询纠正措施',
  'ACorrectiveApi': '新增纠正措施',
  'UCorrectiveApi': '编辑纠正措施',
  'DCorrectiveApi': '删除纠正措施',
  
  // ===== 生产管理 (produce.js) =====
  'QOutboundApi': '查询原辅料使用',
  'AOutboundApi': '新增原辅料使用',
  'UOutboundApi': '编辑原辅料使用',
  'DOutboundApi': '删除原辅料使用',
  'QFormulasApi': '查询配方投料记录',
  'AFormulasApi': '新增配方投料记录',
  'UFormulasApi': '编辑配方投料记录',
  'DFormulasApi': '删除配方投料记录',
  'QAdditivesApi': '查询食品添加剂',
  'AAdditivesApi': '新增食品添加剂',
  'UAdditivesApi': '编辑食品添加剂',
  'DAdditivesApi': '删除食品添加剂',
  'QDeviceManageApi': '查询设备管理',
  'ADeviceManageApi': '新增设备管理',
  'UDeviceManageApi': '编辑设备管理',
  'DDeviceManageApi': '删除设备管理',
  'QPocessControlApi': '查询生产加工过程',
  'APocessControlApi': '新增生产加工过程',
  'UPocessControlApi': '编辑生产加工过程',
  'DPocessControlApi': '删除生产加工过程',
  'QTechnologyApi': '查询生产工艺参数',
  'ATechnologyApi': '新增生产工艺参数',
  'UTechnologyApi': '编辑生产工艺参数',
  'DTechnologyApi': '删除生产工艺参数',
  'QInspectsApi': '查询留存样品',
  'AInspectsApi': '新增留存样品',
  'UInspectsApi': '编辑留存样品',
  'DInspectsApi': '删除留存样品',
  
  // ===== 贮存/运输 (refrigerate.js) =====
  'QRefrigerateApi': '查询贮存管理',
  'ARefrigerateApi': '新增贮存管理',
  'URefrigerateApi': '编辑贮存管理',
  'DRefrigerateApi': '删除贮存管理',
  'QMonitorsApi': '查询定期监测记录',
  'AMonitorsApi': '新增定期监测记录',
  'UMonitorsApi': '编辑定期监测记录',
  'DMonitorsApi': '删除定期监测记录',
  'QTransportsApi': '查询运输过程记录',
  'ATransportsApi': '新增运输过程记录',
  'UTransportsApi': '编辑运输过程记录',
  'DTransportsApi': '删除运输过程记录',
  'QCallHandleApi': '查询召回产品处理',
  'ACallHandleApi': '新增召回产品处理',
  'UCallHandleApi': '编辑召回产品处理',
  'DCallHandleApi': '删除召回产品处理',
  
  // ===== 首页/统计 (statistic.js) =====
  'QHomeApi': '查询首页统计',
  'MessageNotifyApi': '消息通知',
  
  // ===== 账户/用户 (account.js / user.js) =====
  'get_token': '用户登录',
  'refresh_token': '刷新令牌',
  'set_password': '修改密码',
  'reset_password': '重置密码',
  'common_functions': '常用功能',
  'set_common_functions': '设置常用功能',
  'make_code': '生成验证码',
  'register': '用户注册',
  'ANoticeUserApi': '消息已读',
  
  // ===== 基础数据 (basicData.js / goods.js) =====
  'clients': '客户管理',
  'suppliers': '供应商管理',
  'warehouses': '仓库管理',
  'goods_categories': '产品分类',
  'goods': '产品信息',
  'goods_units': '产品单位',
  
  // ===== 报表 (report.js) =====
  'GroupByClientApi': '按客户汇总',
  'GroupBySupplierApi': '按供应商汇总',
  
  // ===== 其他通用操作 =====
  'UploadApi': '文件上传',
  'ExportApi': '数据导出',
  'ImportApi': '数据导入',
  
  // 通用模式匹配
  // Q开头: 查询, A开头: 新增, U开头: 更新, D开头: 删除
};

/**
 * 解析操作内容，将JSON参数转换为友好描述
 * @param {string} content - 操作内容（通常是JSON字符串或对象字符串）
 * @param {string} operationName - 操作名称（用于判断上下文）
 * @returns {string} 友好的描述文本
 */
export function parseOperationContent(content, operationName = '') {
  if (!content || content === '{}' || content === '[]') return '无';
  
  try {
    // 尝试解析为对象
    let data;
    if (typeof content === 'string') {
      // 处理Python字典格式（单引号转双引号）
      let jsonStr = content.replace(/'/g, '"').replace(/None/g, 'null').replace(/True/g, 'true').replace(/False/g, 'false');
      
      // 🔧 容错处理：如果JSON被截断，尝试修复
      // 1. 移除末尾不完整的部分
      // 可能的截断模式：
      // - ", 'item_name': '标签和说明书'"  (未闭合的字符串值)
      // - ", 'item_name"  (未完成的字段名)
      // - ", 'item_name': {'id"  (未闭合的对象)
      jsonStr = jsonStr.replace(/,\s*"[^"]*:\s*"[^"]*\s*$/, '');  // 移除未闭合的字符串值
      jsonStr = jsonStr.replace(/,\s*"[^"]*:\s*\{[^}]*\s*$/, '');  // 移除未闭合的对象
      jsonStr = jsonStr.replace(/,\s*"[^"]*"\s*$/, '');  // 移除末尾的字段名
      jsonStr = jsonStr.replace(/,\s*$/, '');  // 移除末尾的逗号
      
      // 🚨 特殊处理：如果包含错误信息（失败的操作）
      // 格式：{error: '该产品已经存在', request: {...}}
      const errorMatch = jsonStr.match(/\{error:\s*['"]([^'"]+)['"]/i);
      if (errorMatch) {
        return `❌ ${errorMatch[1]}`;
      }
      
      // 2. 统计括号和引号数量
      let openBraces = (jsonStr.match(/{/g) || []).length;
      let closeBraces = (jsonStr.match(/}/g) || []).length;
      let openBrackets = (jsonStr.match(/\[/g) || []).length;
      let closeBrackets = (jsonStr.match(/\]/g) || []).length;
      let quoteCount = (jsonStr.match(/"/g) || []).length;
      
      // 3. 修复未闭合的引号（先修复引号，再修复括号）
      if (quoteCount % 2 !== 0) {
        jsonStr += '"';
      }
      
      // 4. 补全缺失的括号
      if (openBrackets > closeBrackets) {
        jsonStr += ']'.repeat(openBrackets - closeBrackets);
      }
      if (openBraces > closeBraces) {
        jsonStr += '}'.repeat(openBraces - closeBraces);
      }
      
      console.log('🔧 JSON修复结果:', { 原始长度: content.length, 修复后长度: jsonStr.length });
      
      data = JSON.parse(jsonStr);
    } else {
      data = content;
    }
    
    // 提取关键字段进行友好显示
    const parts = [];
    
    // 常见字段映射
    const fieldMap = {
      // 基础字段
      'name': '名称',
      'product_name': '产品名称',
      'product_id': '产品ID',
      'title': '标题',
      'description': '描述',
      'remark': '备注',
      'remarks': '备注',
      'error': '错误信息',
      'message': '消息',
      
      // 分页字段
      'page': '页码',
      'page_size': '每页数量',
      'search': '搜索',
      
      // 状态字段
      'status': '状态',
      'state': '状态',
      'is_default': '默认模板',
      'finish': '按时完成',
      
      // 系统字段
      'team_id': '团队ID',
      'merchant_id': '商户ID',
      'username': '用户名',
      'operator': '操作人',
      'executor': '执行人',
      'head': '负责人',
      'recorder': '记录人',
      'reviewer': '复核人',
      'update_name': '编辑人',
      'updata_id': '编辑人ID',
      
      // 时间字段
      'start_time': '开始时间',
      'end_time': '结束时间',
      'create_at': '创建时间',
      'update_at': '更新时间',
      'produce_time': '生产日期',
      'action_time': '任务日期',
      'check_time': '检查时间',
      'check_date': '任务日期',
      'meeting_date': '会议时间',
      
      // 召回管理字段
      'number': '编号',
      'reason': '原因',
      'others': '详细信息',
      
      // 模板相关字段
      'template_name': '模板名称',
      'template_id': '模板ID',
      'template_no': '模板编号',
      'template_type': '模板类型',
      'item_name': '项目名称',
      'item_no': '项目编号',
      'related_items': '关联项目',
      'star': '重要级别',
      'sort_order': '排序',
      'input_type': '输入类型',
      'option_id': '选项ID',
      'parent_item_id': '父项目ID',
      
      // 日管控相关
      'check_no': '检查编号',
      'check_result': '检查结果',
      'check_list': '检查清单',
      'illustrate': '说明',
      'advice': '意见',
      'sign': '签字',
      'total_items': '总项目数',
      'not_conform_items': '不符合项',
      
      // 周排查相关
      'troubleshooting': '本周排查',
      'control_date': '控制时间',
      'measures': '整改措施',
      'participants': '参加人员',
      'record_code': '记录编号',
      'review': '上周回顾',
      
      // 月调度相关
      'meeting_name': '会议名称',
      'host': '主持人',
      'meeting_location': '会议地点',
      'attendance': '出席人员',
      'meeting_record': '会议内容',
      'months_plan': '下月计划',
      'reported_by': '汇报人',
      
      // 追溯相关
      'batch': '批次号',
      'formula': '配方',
      'trace_code': '追溯码',
      'product_specs': '产品规格',
      'product_brand': '品牌',
      'sales_area': '销售区域',
      'product_type': '产品类型',
      'standards': '执行标准',
      'period': '保质期',
      'commpany': '生产企业',
      'adreess': '生产地址',
      'introduce': '产品介绍',
      'ingredients': '配料表',
      'bar_code': '条形码',
      'licence_no': '许可证编号',
      'net_content': '净含量',
      'hoarding': '储存条件',
      
      // 配方投料相关
      'material': '原材料',
      'situation': '情况',
      'start': '开始时间',
      'end': '结束时间',
      
      // 从业人员/企业相关
      'phone': '电话',
      'address': '地址',
      'leader': '部门领导',
      'parent_id': '父级ID',
      'is_platform': '平台标识',
      
      // 其他业务字段
      'date': '日期',
      'icon': '图标',
      'result': '结果',
      'image': '图片',
      'images': '图片',
      'covers': '封面图',
      'video': '视频',
      'content': '内容',
      'details': '详情',
      'pdt_id': '商品ID',
      'cate_id': '分类ID',
      'author': '作者',
      'logo': '标识',
      'tag': '标签',
      'code': '编码',
      'category': '分类'
    };
    
    // 优先显示的字段顺序
    const priorityFields = [
      'name', 'product_name', 'template_name', 'title', 'description', 
      'search', 'username', 'operator', 'executor', 'number', 'reason',
      'check_no', 'meeting_name', 'batch'
    ];
    
    // 先处理 others 嵌套对象（召回管理等场景）
    if (data.others && typeof data.others === 'object') {
      const othersData = data.others;
      for (const field of priorityFields) {
        if (othersData[field] !== undefined && othersData[field] !== null && othersData[field] !== '') {
          const label = fieldMap[field] || field;
          parts.push(`${label}: ${othersData[field]}`);
        }
      }
    }
    
    // 处理优先字段
    for (const field of priorityFields) {
      if (data[field] !== undefined && data[field] !== null && data[field] !== '' && field !== 'others') {
        const label = fieldMap[field] || field;
        const value = typeof data[field] === 'object' ? JSON.stringify(data[field]).substring(0, 50) : data[field];
        parts.push(`${label}: ${value}`);
      }
    }
    
    // 如果是分页查询，简化显示
    if (data.page !== undefined || data.page_size !== undefined) {
      if (parts.length === 0) {
        const pageInfo = [];
        if (data.page) pageInfo.push(`第${data.page}页`);
        if (data.page_size) pageInfo.push(`每页${data.page_size}条`);
        if (pageInfo.length > 0) parts.push(pageInfo.join(', '));
      }
    }
    
    // 如果有搜索条件
    if (data.search !== undefined && data.search !== '') {
      parts.push(`搜索: ${data.search}`);
    }
    
    // 处理 related_items（模板关联项目）- 优先显示，重要信息
    if (data.related_items && Array.isArray(data.related_items)) {
      const itemCount = data.related_items.length;
      if (itemCount > 0) {
        // 提取项目名称列表（最多显示3个）
        const itemNames = data.related_items
          .slice(0, 3)
          .map(item => item.item_name || item.name)
          .filter(Boolean);
        
        if (itemNames.length > 0) {
          const displayNames = itemNames.join('、');
          const moreText = itemCount > 3 ? `等${itemCount}项` : '';
          parts.unshift(`包含项目: ${displayNames}${moreText}`);  // 使用 unshift 放在最前面
        } else {
          parts.unshift(`关联${itemCount}个项目`);
        }
      }
    }
    
    // 处理模板ID（用于标识具体是哪个模板）
    if (data.id !== undefined && data.id !== null) {
      // 如果操作名称包含"模板"相关，显示模板ID
      if (operationName && (operationName.includes('Template') || operationName.includes('模板'))) {
        parts.push(`模板ID: ${data.id}`);
      }
    }
    
    // 处理其他重要字段（排除已处理和系统字段）
    const excludeFields = [
      ...priorityFields, 
      'page', 'page_size', 'per_page',
      'team_id', 'merchant_id', 
      'create_at', 'update_at',
      'others', 'related_items',  // 已特殊处理的字段
      'id'  // 已在上面特殊处理
    ];
    const otherFields = Object.keys(data).filter(key => 
      !excludeFields.includes(key) && 
      data[key] !== undefined && 
      data[key] !== null && 
      data[key] !== '' &&
      data[key] !== 0  // 排除值为0的字段（如 is_default: 0）
    );
    
    // 最多显示1个其他字段（进一步减少显示，避免太长）
    for (const field of otherFields.slice(0, 1)) {
      const label = fieldMap[field] || field;
      let value = data[field];
      
      // 特殊处理：布尔值或0/1状态
      if (field === 'is_default') {
        value = value === 1 ? '是' : '否';
      } else if (typeof value === 'object') {
        // 对象类型直接跳过，不显示
        continue;
      } else if (String(value).length > 20) {
        value = String(value).substring(0, 20) + '...';
      }
      
      parts.push(`${label}: ${value}`);
    }
    
    if (parts.length > 0) {
      // 限制总长度，避免显示过长（调整为100字符，更简洁）
      const result = parts.join('; ');
      return result.length > 100 ? result.substring(0, 100) + '...' : result;
    }
    
    // 如果没有提取到有用信息，返回简化的JSON
    const simplified = JSON.stringify(data).substring(0, 80);
    return simplified.length < JSON.stringify(data).length ? simplified + '...' : simplified;
    
  } catch (e) {
    // 解析失败，返回原始内容的前100个字符
    return String(content).substring(0, 100) + (content.length > 100 ? '...' : '');
  }
}

/**
 * 智能提取操作名称
 * @param {string} name - 原始操作名(如 "POST /frontApis/shop/v1/dailyItem/QDailyItemApi" 或 "GET MessageNotifyApi")
 * @returns {string} 友好的中文名称
 */
export function getOperationDisplay(name) {
  if (!name) return '';
  
  try {
    const nameStr = String(name).trim();
    
    // 1. 尝试直接精确匹配（完整路径）
    if (API_NAME_MAP[nameStr]) return API_NAME_MAP[nameStr];
    
    // 1.5 尝试匹配完整的 HTTP 路径格式（如 "POST /frontApis/shop/v1/..."）
    const fullPathMatch = nameStr.match(/^(GET|POST|PUT|DELETE|PATCH)\s+(.+)$/);
    if (fullPathMatch && API_NAME_MAP[nameStr]) {
      return API_NAME_MAP[nameStr];
    }
    
    // 2. 提取 API 名称部分(支持多种格式)
    // 格式1: "GET MessageNotifyApi" -> MessageNotifyApi
    // 格式2: "POST /path/to/QDailyControlApi22" -> QDailyControlApi22
    // 格式3: "QDailyControlApi22" -> QDailyControlApi22
    
    let apiName = null;
    
    // 先尝试正则匹配API名称模式 (大写字母开头 + 字母数字 + Api + 可选数字)
    const apiMatch = nameStr.match(/\b([A-Z][A-Za-z0-9]*Api\d*)\b/);
    if (apiMatch) {
      apiName = apiMatch[1];
    }
    
    // 如果没找到，尝试从简单格式提取 (如 "GET MessageNotifyApi")
    if (!apiName) {
      const parts = nameStr.split(/\s+/);
      if (parts.length === 2 && /^[A-Z]+$/.test(parts[0])) {
        // parts[0] 是 HTTP 方法, parts[1] 是 API 名
        apiName = parts[1];
      } else if (parts.length === 1) {
        // 只有一个部分,可能就是API名称
        apiName = parts[0];
      }
    }
    
    // 3. 使用提取的API名称查找映射
    if (apiName && API_NAME_MAP[apiName]) {
      return API_NAME_MAP[apiName];
    }
    
    // 4. 智能模式识别 (Q/A/U/D前缀)
    if (apiName && /^[QAUD][A-Z]/.test(apiName)) {
      const prefix = apiName.charAt(0);
      const actionMap = {
        'Q': '查询',
        'A': '新增', 
        'U': '编辑',
        'D': '删除'
      };
      
      if (actionMap[prefix]) {
        // 提取业务名称(去掉前缀和Api后缀及数字)
        let businessName = apiName.substring(1).replace(/Api\d*$/, '');
        // 驼峰转空格 (如 DailyControl -> Daily Control)
        businessName = businessName.replace(/([A-Z])/g, ' $1').trim();
        return `${actionMap[prefix]} ${businessName}`;
      }
    }
    
    // 5. 路径关键词匹配
    const lowerName = nameStr.toLowerCase();
    const keywordMap = {
      'message': '消息',
      'notify': '通知',
      'home': '首页',
      'daily': '日管控',
      'week': '周排查',
      'month': '月调度',
      'employee': '从业人员',
      'merchant': '企业',
      'trace': '追溯',
      'intelligence': '智能化',
      'refrigerate': '贮存',
      'transport': '运输',
      'call': '召回',
      'unqualified': '不合格品',
      'template': '模板',
      'record': '记录',
      'item': '项目',
      'child': '子项'
    };
    
    for (const [keyword, chinese] of Object.entries(keywordMap)) {
      if (lowerName.includes(keyword)) {
        // 提取HTTP方法
        const methodMatch = nameStr.match(/^(GET|POST|PUT|DELETE|PATCH)/);
        if (methodMatch) {
          const methodMap = {
            'GET': '查询',
            'POST': '操作',
            'PUT': '更新',
            'DELETE': '删除',
            'PATCH': '更新'
          };
          return `${methodMap[methodMatch[1]] || methodMatch[1]} ${chinese}`;
        }
        return chinese;
      }
    }
    
    // 6. 回退：保留原始但格式化
    // 如果是 "GET SomeApi" 格式，尝试美化
    const parts = nameStr.split(/\s+/);
    if (parts.length >= 2 && /^(GET|POST|PUT|DELETE|PATCH)$/.test(parts[0])) {
      const lastPart = parts[parts.length - 1];
      // 移除路径分隔符
      const cleanName = lastPart.split('/').pop();
      return `${parts[0]} ${cleanName}`;
    }
    
  } catch (e) {
    console.warn('解析操作名失败:', name, e);
  }
  
  // 最终回退：返回原文
  return String(name);
}

export { API_NAME_MAP };
